import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { bookmarksEntity } from './bookmarks.models';
import { Action, createReducer, on } from '@ngrx/store';
import * as BookmarksActions from './bookmarks.actions';

export const BOOKMARKS_FEATURE_KEY = 'bookmarks';

export interface BookmarksState extends EntityState<bookmarksEntity> {
  response: bookmarksEntity | null;
  loaded: boolean;
  error?: string | null;
  documentId?: number | null;
}

export const bookmarksAdapter: EntityAdapter<bookmarksEntity> = createEntityAdapter<bookmarksEntity>();

export const initialBookmarksState: BookmarksState = bookmarksAdapter.getInitialState({
  response: null,
  loaded: true,
  error: null,
  documentId: null,
});

const reducer = createReducer(
  initialBookmarksState,
  on(BookmarksActions.setBookmark, (state, { documentId }) => ({
    ...state,
    loaded: false,
    error: null,
    documentId: documentId,
  })),
  on(BookmarksActions.setBookmarkSuccess, (state, { response }) => ({
    ...state,
    response: response,
    loaded: true,
    error: null,
  })),
  on(BookmarksActions.setBookmarkFailure, (state, { error }) => ({
    ...state,
    loaded: true,
    error: error,
  })),
  on(BookmarksActions.deleteBookmark, (state, { documentId }) => ({
    ...state,
    loaded: false,
    error: null,
    documentId: documentId,
  })),
  on(BookmarksActions.deleteBookmarkSuccess, (state, { response }) => ({
    ...state,
    response: response,
    loaded: true,
    error: null,
  })),
  on(BookmarksActions.deleteBookmarkFailure, (state, { error }) => ({
    ...state,
    loaded: true,
    error: error,
  }))
);

export function bookmarksReducer(state: BookmarksState | undefined, action: Action) {
  return reducer(state, action);
}
